// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"format-horizontal-align-center"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5 21L5 3M12 18L12 6M19 21L19 3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FormatHorizontalAlignCenterIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'format-horizontal-align-center',
    ref,
    icon: element,
  },
));

FormatHorizontalAlignCenterIcon.displayName = 'FormatHorizontalAlignCenterIcon';

export default FormatHorizontalAlignCenterIcon;
